import { TRUSTED_PARTNERS_STRINGS as S } from '../trusted-partners.constants';

export interface TrustedPartnersHeroProps {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
}

/**
 * Dark hero band at the top of the Trusted Partners page (Figma "Trusted
 * Partners"). The Startup Perks page reuses it with its own copy (MYN-252), so
 * the copy is a prop defaulting to the Trusted Partners text.
 */
export function TrustedPartnersHero({
  eyebrow = S.HERO_EYEBROW,
  title = S.HERO_TITLE,
  subtitle = S.HERO_SUBTITLE,
}: TrustedPartnersHeroProps) {
  return (
    <section className="relative overflow-hidden rounded-card bg-gradient-to-br from-navy to-teal px-8 py-8 text-white">
      <p className="text-[10px] font-semibold uppercase tracking-widest text-green">{eyebrow}</p>
      <h2 className="mt-2 text-2xl font-semibold">{title}</h2>
      <p className="mt-2 max-w-xl text-p6 text-white/80">{subtitle}</p>
      <span aria-hidden="true" className="absolute -right-8 -top-8 h-40 w-40 rounded-full bg-white/5" />
      <span aria-hidden="true" className="absolute right-8 top-6 h-24 w-24 rounded-full bg-white/5" />
    </section>
  );
}
